import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';

import {
    Paper,
    Divider,
    styled,
    Grid,
    Box,
    Button,
    Modal,
    Typography,
    Card,
    CardHeader,
    CardContent
} from "@mui/material";
import {
  Collapse, IconButton, 
} from '@mui/material';
import Autocomplete from "@mui/material/Autocomplete";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { fetchAddressBookDetails } from './addressbookSlice';
import { fetchCountry, fetchState, fetchMultiStates } from '../../../pages/General/countryStateCitySlice';
import { fetchSenderAddress } from '../../../pages/Settings/AddressSender/addressSenderSlice';

const SenderAddressSelect = ({ values,errors, addresssender, isReturnOrder, senderAddressObjectId, dispatchSenderAddressCallback, dispatchSenderCountryCallback, dispatchInputChangeCallback,setValues }) => {
    const dispatch = useDispatch();
    const country_code = useSelector(state => state.countrystate.country);
    const state = useSelector(state => state.countrystate.multistates);
    const addressbooksearchvalues = useSelector((state) => state.addressbook && state.addressbook.getsearchvalues);
    const [addressSearchBy, setAddressSearchBy] = useState("name");
    const [addressSearchByValue, setAddressSearchByValue] = useState("");
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const onChangeCountry = id => {
        dispatchSenderCountryCallback(id)
    }
    const onsenderaddresschange = (id) => {
        dispatchSenderAddressCallback(id)
    }
    
    const handleInputChange = e => {
        const { name, value } = e.target
        dispatchInputChangeCallback(name, value)
    }

    useEffect(() => {
        dispatch(fetchSenderAddress());
    }, [dispatch]);

    useEffect(() => {
        if (values.sender_country_code && values.sender_country_code!='') {
            dispatch(fetchMultiStates(values.sender_country_code));
        }
    }, [values.sender_country_code]);

    
      const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };

      const onSelectStateChange = (currentstate) => {
        dispatchInputChangeCallback("sender_province_code", currentstate)
      };
    
      const getSelectedState = (currentstate) => {
        let filteredStateValue = { code: "", name: "" };
        let tempState = "";
        state &&
          state.data &&
          state.data.map((key) => {
            if (key.code == currentstate && tempState == "") {
              filteredStateValue = key;
              tempState = "success";
            }
          });
        return filteredStateValue;
      };

       useEffect(() => {
              if(isReturnOrder==undefined || isReturnOrder==false){
                  dispatch(fetchAddressBookDetails(addressSearchBy, ""))
              }
          }, [addressSearchBy])
      
          useEffect(() => {
              if(isReturnOrder==undefined || isReturnOrder==false){
                  dispatch(fetchAddressBookDetails(addressSearchBy, addressSearchByValue))
              }
          }, [addressSearchByValue])
      
          const [labelgetvalues, setlabelgetvalues] = useState([]);
      
      
          const onSearchLabelChange = (event, value) => {
              if (value != null && value != "") {
                  setValues({
                      ...values,
                      sender_name: value.name ? value.name : "",
                      sender_company: value.company ? value.company : "",
                      sender_phone: value.phone ? value.phone : "",
                      sender_email: value.email ? value.email : "",
                      sender_address: value.address ? value.address : "",
                      sender_address2: value.address2 ? value.address2 : "",
                      sender_city: value.city ? value.city : "",
                      sender_postal_code: value.postal_code ? value.postal_code : "",
                      sender_country_code: value.country_code ? value.country_code.toUpperCase() : "",
                      sender_province_code: value.province_code ? value.province_code.toUpperCase() : ""
                  });
                  dispatch(fetchState(value.country_code));
                  
              }
          }
      
          useEffect(() => {
              if (addressbooksearchvalues && addressbooksearchvalues.data) {
                  let searchvaluearray = []
                  Object.entries(addressbooksearchvalues.data).map((entry) => {
                      entry.map((item) => {
                          if (typeof item == "object") {
                              searchvaluearray.push(item)
                          }
                      });
                  });
                  setlabelgetvalues(searchvaluearray)
              }
          }, [addressbooksearchvalues.data]);
            const [isExpanded, setIsExpanded] = useState(false);

            const handleToggleExpand = () => {
                setIsExpanded(!isExpanded);
            };

    return (
        <>
            <Grid xs={6} md={6} style={{ width: '50%', padding: '10px' }}>
                <Card
                    sx={{ minWidth: 275, boxShadow: 'unset', border: '1px solid rgba(0, 0, 0, 0.12)'}}
                    className="sc--cardhead--details">
                    <CardHeader title='Sender' 
                    action={
                            <IconButton onClick={handleToggleExpand}>
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        }
                        onClick={handleToggleExpand}
                        style={{ cursor: 'pointer' }}
                    />
                    <Divider />
                        {isReturnOrder ?
                             <>
                              <CardContent>
                             <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                <FormControl
                                    variant="standard"
                                    className="help-text-error"
                                    style={{ width: '20%', margin: '8px' }}
                                >
                                    <InputLabel
                                        style={{ color: errors.dimension_unit ? "#D32F2F" : '' }}
                                    > Search by
                                </InputLabel>
                                    <Select
                                        name="search_by"
                                        onChange={(event) => { setAddressSearchBy(event.target.value) }}
                                        value={addressSearchBy}
                                        label="Search by"
                                        id="filled-error-helper-text"
                                    >
                                        <MenuItem value="name">Name</MenuItem>
                                        <MenuItem value="company">Company</MenuItem>
                                        <MenuItem value="address">Address</MenuItem>
                                        <MenuItem value="address2">Addres2</MenuItem>
                                        <MenuItem value="city">City</MenuItem>
                                        <MenuItem value="province_code">Province code</MenuItem>
                                        <MenuItem value="country_code">Country code</MenuItem>
                                        <MenuItem value="postal_code">Postal code</MenuItem>
                                        <MenuItem value="email">Email</MenuItem>
                                        <MenuItem value="phone">Phone</MenuItem>
                                        <MenuItem value="customer_id">Customer id</MenuItem>
                                        <MenuItem value="reference">Reference</MenuItem>
                                        <MenuItem value="reference2">Reference2</MenuItem>
                                        <MenuItem value="reference3">Reference3</MenuItem>
                                    </Select>
                                </FormControl>
                                <Autocomplete
                                    disablePortal
                                    name="search_value"
                                    id="combo-box-demo"
                                    noOptionsText={"No matches found"}
                                    loading={addressbooksearchvalues && addressbooksearchvalues.loading}
                                    options={labelgetvalues}
                                    filterOptions={(options) => options}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} value={option._id} key={option._id}>
                                        <p style={{ margin: 'unset' }} key={option._id}>{option.name} ({option.company})<br />
                                            {option.address}, {option.city}, {option.province_code}, {option.country_code} - {option.postal_code}
                                        </p>
                                    </MenuItem>
                                    )}
                                    onInputChange={(event, value, reason) => {
                                            if ( ! value.includes(",") && reason != "reset") {
                                                setAddressSearchByValue(value)
                                            }
                                        }
                                    }
                                    onChange={(event, value) => onSearchLabelChange(event, value)}
                                    style={{ width: 480, margin: '8px' }}
                                    getOptionLabel={(option) => ( ""+option.name+" ("+option.company+")"+", "+ option.address ) }
                                    renderInput={(params) => <TextField 
                                        {...params} 
                                        label="Search" 
                                        style={{ width: '95%' }} 
                                        variant="standard"
                                         />}
                                />
                            </div>
                            </CardContent>
                             </>
                             :
                             <>
                             <CardContent>
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                <FormControl
                                    variant="standard"
                                    style={{ width: "68ch", margin: '8px' }} >
                                    <InputLabel
                                        id="demo-simple-select-standard-label"
                                        style={{ color: errors.preferred_sender_id ? "#D32F2F" : '' }}
                                    >Sender Address
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        name="preferred_sender_id"
                                        value={senderAddressObjectId}
                                        error={errors.preferred_sender_id}
                                        onChange={e => {
                                            onsenderaddresschange(e.target.value,false)
                                            // setErrors({ "preferred_sender_id": "" })
                                        }}
                                        label="Sender Address"
                                    >
                                        {addresssender && addresssender.data && addresssender.data.map((item) => {
                                            return (
                                                <MenuItem value={item._id}>
                                                    <p style={{ margin: 'unset' }}>{item.sender_name} ({item.sender_company})<br />
                                                        {item.sender_address}, {item.sender_city}, {item.sender_state_code}, {item.sender_country_code} - {item.sender_postal_code}
                                                    </p>
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>

                                    <FormHelperText>
                                        {(addresssender && addresssender.loading === false)
                                            && addresssender && addresssender.data && addresssender.data.length == 0 &&
                                            <span style={{ color: "red" }}>
                                                Please add sender address
                                            <Link to="/settings/address-sender" style={{ color: 'blue', textDecoration: 'none' }}> here </Link>
                                            </span>
                                        }
                                        {errors.preferred_sender_id && addresssender && addresssender.data && addresssender.data.length !== 0 &&
                                            <span style={{ color: "red" }}>
                                                This field is required.
                                            </span>
                                        }
                                    </FormHelperText>
                                </FormControl>
                            </div>
                           
                            
                            </CardContent>
                            </>
                        }
                        <CardContent>
                          <div className="sc--form--center">
                                <TextField id="standard-basic"
                                    label="Name*"
                                    variant="standard"
                                    name="sender_name"
                                    value={values.sender_name}
                                    onChange={handleInputChange}
                                    error={errors.sender_name}
                                    helperText={errors.sender_name}
                                    style={{ width: "100%",margin:"8px"  }}
                                />
                                <TextField id="standard-basic"
                                    label="Company"
                                    variant="standard"
                                    name="sender_company"
                                    value={values.sender_company!==""?values.sender_company:""}
                                    onChange={handleInputChange}
                                    error={errors.sender_company}
                                    helperText={errors.sender_company}
                                    style={{ width: "100%",margin:"8px"  }} />

                                <TextField id="standard-basic"
                                    label="Phone Number"
                                    name="sender_phone"
                                    value={values.sender_phone}
                                    variant="standard"
                                    onChange={handleInputChange}
                                    style={{ width: "100%",margin:"8px"  }}
                                />
                            </div>
                        </CardContent>
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1 },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                           <div className="sc--form--center">
                                <TextField id="standard-basic"
                                    label="Email"
                                    variant="standard"
                                    name="sender_email"
                                    value={values.sender_email}
                                    onChange={handleInputChange}
                                    error={errors.sender_email}
                                    helperText={errors.sender_email}
                                    style={{ width: "100%" }} />

                                <TextField id="standard-basic"
                                    label="Address1*"
                                    variant="standard"
                                    name="sender_address"
                                    value={values.sender_address}
                                    inputProps={{ maxLength: 35 }}
                                    onChange={handleInputChange}
                                    error={errors.sender_address}
                                    helperText={errors.sender_address}
                                    style={{ width: "100%" }} />

                                <TextField id="standard-basic"
                                    label="Address2"
                                    variant="standard"
                                    name="sender_address2"
                                    value={values.sender_address2}
                                    inputProps={{ maxLength: 35 }}
                                    onChange={handleInputChange}
                                    error={errors.sender_address2}
                                    helperText={errors.sender_address2}
                                    style={{ width: "100%" }} />
                            </div>
                            <div className="sc--form--center">
                                <TextField id="standard-basic"
                                    label="City*"
                                    variant="standard"
                                    name="sender_city"
                                    value={values.sender_city}
                                    onChange={handleInputChange}
                                    error={errors.sender_city}
                                    helperText={errors.sender_city}
                                    style={{ width: "100%" }} />
                                <TextField id="standard-basic"
                                    label="Postal Code*"
                                    variant="standard"
                                    name="sender_postal_code"
                                    inputProps={{ maxLength: 10}}
                                    value={values.sender_postal_code}
                                    onChange={handleInputChange}
                                    error={errors.sender_postal_code}
                                    helperText={errors.sender_postal_code}
                                    style={{ width: "100%" }} />

                                <Autocomplete
                                className="help-text-error"
                                disablePortal
                                name="sender_country_code"
                                id="country-select-demo"
                                sx={{ width: "100%"}}
                                options={filteredCountryData}
                                autoHighlight
                                loading={country_code && country_code.loading}
                                getOptionLabel={(option) => option.name}
                                value={getSelectedCountry(values && values.sender_country_code)}
                                renderOption={(props, option) => (
                                <MenuItem {...props} value={option.code} key={option.code}>
                                    {option.icon} {option.name}
                                </MenuItem>
                                )}
                                onChange={(event, value) => {
                                if (value !== null) {
                                    onChangeCountry(value.code);
                                } else {
                                    onChangeCountry("");
                                }
                                }}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="country*"
                                    variant="standard"
                                    helperText={errors.sender_country_code}
                                    error={errors.sender_country_code}
                                />
                                )}
                            />
                            </div>
                            <div className="sc--form--center" >
                            <Autocomplete
                                className="help-text-error"
                                disablePortal
                                name="sender_province_code"
                                id="state-select-demo"
                                sx={{ width: "100%",margin:'8px'}}
                                options={state && state.data}
                                autoHighlight
                                loading={
                                (state && state.loading) || (country_code && country_code.loading)
                                }
                                getOptionLabel={(option) => option.name}
                                value={getSelectedState(values && values.sender_province_code)}
                                renderOption={(props, option) => (
                                <MenuItem {...props} value={option.code} key={option.code}>
                                    {option.name}
                                </MenuItem>
                                )}
                                onChange={(event, value) => {
                                    if (value !== null) {
                                      onSelectStateChange(value.code);
                                    } else {
                                      onSelectStateChange("");
                                    }
                                  }}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="state*"
                                    variant="standard"
                                    helperText={errors.sender_province_code}
                                    error={errors.sender_province_code}
                                />
                                )}
                            />
                             <TextField id="standard-basic"
                                    label="Reference no"
                                    variant="standard"
                                    name="sender_reference_no"
                                    value={values.sender_reference_no}
                                    inputProps={{ maxLength: 35 }}
                                    onChange={handleInputChange}
                                    style={{ width: "68ch", margin: '8px' }}
                             />
                            </div>
                        </Box>
                    </CardContent>
                    </Collapse>
                </Card>
            </Grid>
        </>
    )
};

export default SenderAddressSelect;